import { Accordion, AccordionDetails, AccordionSummary, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { TitleText } from '../../../component/layout/layoutMainStyle';
import { useEffect, useState } from 'react';
import FolderApi from '../../../api/folder/folder.api';
import moment from 'moment';
type PropsDialogDetail = {
    open: boolean
    handleClose: any
    idFolder: number
}
export default function DialogDetail(props: PropsDialogDetail) {
    const { open, handleClose, idFolder } = props
    const [data, setData] = useState<any>()
    const loadDataLevel = async () => {
        const res = await FolderApi.getMyFolder(idFolder)
        const data = await res.data;
        if (data?.success) {
            setData(data.result)
        }
    }
    useEffect(() => {
        if (open) {
            loadDataLevel()
        }

    }, [open])
    return (
        <Dialog
            open={open}
            keepMounted
            onClose={() => handleClose(false)}
            fullWidth
            maxWidth='sm'
        >
            <DialogTitle sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <ClearIcon sx={{ cursor: 'pointer', fontSize: "20px" }} onClick={() => handleClose(false)} />
            </DialogTitle>
            <DialogContent sx={{ padding: '32px', gap: '32px', display: 'flex', flexDirection: "column" }}>
                <div style={{ display: "flex", justifyContent: 'center', width: '100%' }}>
                    <TitleText>รายละเอียด</TitleText>
                </div>
                <Accordion defaultExpanded sx={{
                    boxShadow: 'none', ':before': {
                        content: '""',
                        height: "0px"
                    }
                }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography>รายละเอียดตู้เอกสาร</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <div>
                            <Typography >ชื่อตู้เอกสาร</Typography>
                            <Typography sx={{ fontSize: '14px', fontWeight: "300" }}>{data?.folderName}</Typography>
                        </div>
                        <div>
                            <Typography >แก้ไขล่าสุด</Typography>
                            <Typography sx={{ fontSize: '14px', fontWeight: "300" }}>วันที่ {moment(data?.modifiedDate).add('year', 543).format('DD MMMM YYYY')} </Typography>
                        </div>
                        <div>
                            <Typography >สร้างเมื่อ</Typography>
                            <Typography sx={{ fontSize: '14px', fontWeight: "300" }}>วันที่ {moment(data?.createDate).add('year', 543).format('DD MMMM YYYY')}</Typography>
                        </div>
                        <div>
                            <Typography >ขนาดไฟล์สูงสุด</Typography>
                            <Typography sx={{ fontSize: '14px', fontWeight: "300" }}>{data?.limitSize / 1024 || 0} mb</Typography>
                        </div>
                        <div>
                            <Typography >สถานที่จัดเก็บข้อมูล</Typography>
                            <Typography sx={{ fontSize: '14px', fontWeight: "300" }}>{data?.folderLocation}</Typography>
                        </div>
                        {/* <div>
                            <Typography >ระยะเวลาจัดเก็บข้อมูล (ปี)</Typography>
                            <Typography sx={{ fontSize: '14px', fontWeight: "300" }}>{}</Typography>
                        </div> */}
                        <div>
                            <Typography >การเข้าถึง</Typography>
                            <Typography sx={{ fontSize: '14px', fontWeight: "300" }}>-</Typography>
                        </div>

                    </AccordionDetails>
                </Accordion>
            </DialogContent>

        </Dialog>
    )
}
